import React from "react";
import { Icon } from "@iconify/react";
import FolderIcon from "@material-ui/icons/FolderOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import TitleIcon from "@material-ui/icons/Title";
import FormatUnderlinedOutlinedIcon from "@material-ui/icons/FormatUnderlinedOutlined";
import TouchAppOutlinedIcon from "@material-ui/icons/TouchAppOutlined";
import LinkIcon from "@material-ui/icons/Link";
import SubtitlesOutlinedIcon from "@material-ui/icons/SubtitlesOutlined";
import TableChartOutlinedIcon from "@material-ui/icons/TableChartOutlined";
import GridOnOutlinedIcon from "@material-ui/icons/GridOnOutlined";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import OpenWithIcon from "@material-ui/icons/OpenWith";
import VerticalAlignBottomIcon from "@material-ui/icons/VerticalAlignBottom";
import VerticalAlignCenterIcon from "@material-ui/icons/VerticalAlignCenter";
import VerticalAlignTopIcon from "@material-ui/icons/VerticalAlignTop";
import SpaceBarIcon from "@material-ui/icons/SpaceBar";
import SliderIcon from "@material-ui/icons/Tune";
import SaveIcon from "@material-ui/icons/Save";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import PaletteOutlinedIcon from "@material-ui/icons/PaletteOutlined";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import Rotate90DegreesCcwIcon from "@material-ui/icons/Rotate90DegreesCcw";
import CropIcon from "@material-ui/icons/Crop";
import CheckIcon from "@material-ui/icons/Check";
import ImageAspectRatioIcon from "@material-ui/icons/ImageAspectRatio";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";
import CircleIcon from "@material-ui/icons/RadioButtonUnchecked";
import { Tooltip } from "@material-ui/core";
import CropLandscapeIcon from "@material-ui/icons/CropLandscape";
import SystemLabel from "./SystemLabel";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import ImagesIcon from "@material-ui/icons/PhotoLibraryOutlined";
import FilesIcon from "@material-ui/icons/FileCopyOutlined";
import FontsIcon from "@material-ui/icons/FontDownloadOutlined";
/* import conditionalFlow from "@iconify-icons/bpmn/conditional-flow"; */
import FieldIcon from "@material-ui/icons/ContactMailOutlined";
import EventIcon from "@material-ui/icons/Event";
import RegIcon from "@material-ui/icons/HowToReg";
/* import welcomeWidgetsMenus from "@iconify/icons-dashicons/welcome-widgets-menus"; */
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import DragIcon from "@material-ui/icons/DragIndicator";
import AddBoxIcon from "@material-ui/icons/AddBox";
import ListAddIcon from "@material-ui/icons/PlaylistAdd";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const HorizontalAlignLeftIcon = () => <VerticalAlignBottomIcon style={{ transform: "rotate(90deg)" }} />;
const HorizontalAlignCenterIcon = () => <VerticalAlignCenterIcon style={{ transform: "rotate(90deg)" }} />;
const HorizontalAlignRightIcon = () => <VerticalAlignTopIcon style={{ transform: "rotate(90deg)" }} />;

const UnitIcon = () => <Icon icon="mdi:tape-measure" />;
const HeaderIcon = () => <Icon icon="fluent:document-header-16-regular" />;
const FooterIcon = () => <Icon icon="fluent:document-footer-16-regular" />;
const ContentIcon = () => <Icon icon="fluent:tab-desktop-multiple-20-regular" />;
const BackgroundIcon = () => <Icon icon="fluent:color-background-24-regular" />;
const TextIcon = () => <Icon icon="dashicons:editor-paragraph" />;
const ScrollIcon = () => <Icon icon="fluent:dual-screen-vertical-scroll-24-regular" />;
const ThemeIcon = () => <Icon icon="mdi:palette-advanced" />;
const RightIcon = () => <Icon icon="fluent:padding-right-24-filled" />;
const LeftIcon = () => <Icon icon="fluent:padding-right-24-filled" style={{ transform: "rotate(-180deg" }} />;
const TopIcon = () => <Icon icon="fluent:padding-right-24-filled" style={{ transform: "rotate(-90deg" }} />;
const BottomIcon = () => <Icon icon="fluent:padding-right-24-filled" style={{ transform: "rotate(90deg" }} />;
const PagesIcon = () => <Icon icon="carbon:page-scroll" />;
const CodeIcon = () => <Icon icon="ci:window-code-block" />;
const TemplateIcon = () => <Icon icon="gg:template" />;
const GlobalSettingsIcon = () => <Icon icon="clarity:network-settings-line" />;
const ModuleIcon = () => <Icon icon="mdi:view-module-outline" />;
const AdvandcedSettingsIcon = () => <Icon icon="codicon:settings" />;
const TextEditorIcon = () => <Icon icon="cil:list-rich" />;
const VideoIcon = () => <Icon icon="clarity:video-gallery-line" />;
const SpaceIcon = () => <Icon icon="cil:space-bar" />;
const ContentViewIcon = () => <Icon icon="carbon:name-space" />;
const OrderSummeryIcon = () => <Icon icon="bx:bx-receipt" />;
const ImageIcon = () => <Icon icon="bx:bx-image" />;
const CopyIcon = () => <Icon icon="fluent:copy-select-20-filled" />;
const UploadIcon = () => <Icon icon="feather:upload" />;
/* const ConditionIcon = () => <Icon icon={conditionalFlow} />; */
/* const ContentModuleIcon = () => <Icon icon={welcomeWidgetsMenus} />; */
const QuestionIcon = () => <Icon icon="fluent:calendar-question-mark-16-regular" />;
const SortIcon = () => <Icon icon="bx:bx-sort-down" />;
const OptionsIcon = () => <Icon icon="vaadin:options" />;
const EditorIcon = () => <Icon icon="bpmn:lasso-tool" />;
const MenuItemIcon = () => <Icon icon="ant-design:unordered-list-outlined" />;
const MobileMenuIcon = () => <Icon icon="carbon:mobile" />;
const NarrowIcon = () => <Icon icon="tabler:viewport-narrow" />;

export const CustomIcon = ({ name, className, tooltip }) => {
  const icon = <span className={(className ? `${className} ` : "") + "icon"}>{getIcon(name)}</span>;
  return tooltip ? <Tooltip title={<SystemLabel name={tooltip} />}>{icon}</Tooltip> : icon;
};

const getIcon = (name) => {
  switch (name.toUpperCase()) {
    case "THEME":
      return <ThemeIcon />;
    case "MAIN":
      return <BackgroundIcon />;
    case "MENU":
      return <MenuIcon />;
    case "HEADER":
      return <HeaderIcon />;
    case "FOOTER":
      return <FooterIcon />;
    case "CONTENT":
      return <ContentIcon />;
    case "TITLE":
      return <TitleIcon />;
    case "BUTTON":
      return <TouchAppOutlinedIcon />;
    case "LINK":
      return <LinkIcon />;
    case "SUBTITLE":
      return <SubtitlesOutlinedIcon />;
    case "INPUT":
      return <BorderColorOutlinedIcon />;
    case "PARAGRAPH":
      return <TextIcon />;
    case "LABEL":
      return <FormatUnderlinedOutlinedIcon />;
    case "THEAD":
      return <TableChartOutlinedIcon />;
    case "TCELL":
      return <GridOnOutlinedIcon />;
    case "SCROLL":
      return <ScrollIcon />;
    case "CHECKBOX":
      return <CheckBoxOutlinedIcon />;
    case "FOLDER":
      return <FolderIcon />;
    case "UNIT":
      return <UnitIcon />;
    case "TOP":
      return <TopIcon />;
    case "BOTTOM":
      return <BottomIcon />;
    case "LEFT":
      return <LeftIcon />;
    case "RIGHT":
      return <RightIcon />;
    case "ALL":
      return <OpenWithIcon />;
    case "JUSTIFY_START":
      return <HorizontalAlignLeftIcon />;
    case "JUSTIFY_END":
      return <HorizontalAlignRightIcon />;
    case "JUSTIFY_CENTER":
      return <HorizontalAlignCenterIcon />;
    case "SPACE_BETWEEN":
      return <SpaceBarIcon />;
    case "ALIGN_START":
      return <VerticalAlignTopIcon />;
    case "ALIGN_END":
      return <VerticalAlignBottomIcon />;
    case "ALIGN_CENTER":
      return <VerticalAlignCenterIcon />;
    case "SLIDER":
      return <SliderIcon />;
    case "SAVE":
      return <SaveIcon />;
    case "REDO":
      return <RedoIcon />;
    case "UNDO":
      return <UndoIcon />;
    case "OPENINNEW":
      return <OpenInNewIcon />;
    case "PAGES":
      return <PagesIcon />;
    case "CODE":
    case "HTML":
    case "CSS":
      return <CodeIcon />;
    case "TEMPLATE":
      return <TemplateIcon />;
    case "GLOBAL_SETTINGS":
      return <GlobalSettingsIcon />;
    case "MODULE":
      return <ModuleIcon />;
    case "ADD":
    case "PLUS":
      return <AddIcon />;
    case "CLEAR":
    case "CLOSE":
    case "CANCEL":
      return <ClearIcon />;
    case "ADVANCED_SETTINGS":
      return <AdvandcedSettingsIcon />;
    case "SETTINGS":
      return <SettingsIcon />;
    case "STYLE":
      return <PaletteOutlinedIcon />;
    case "VIDEO":
      return <VideoIcon />;
    case "CONFIRMATION":
      return <OrderSummeryIcon />;
    case "TEXT_EDITOR":
      return <TextEditorIcon />;
    case "IMAGE":
      return <ImageIcon />;
    case "SPACE":
      return <SpaceIcon />;
    case "CONTENT_VIEW":
      return <ContentViewIcon />;
    case "ZOOMIN":
      return <ZoomInIcon />;
    case "ZOOMOUT":
      return <ZoomOutIcon />;
    case "ROTATE":
      return <Rotate90DegreesCcwIcon />;
    case "CROP":
      return <CropIcon />;
    case "CHECK":
      return <CheckIcon />;
    case "ASPECT_RATIO":
      return <ImageAspectRatioIcon />;
    case "FULL_SIZE":
      return <AspectRatioIcon />;
    case "CIRCLE":
      return <CircleIcon />;
    case "NORMAL_SHAPE":
      return <CropLandscapeIcon />;
    case "DELETE":
      return <DeleteOutlineOutlinedIcon />;
    case "COPY":
      return <CopyIcon />;
    case "UPLOAD":
      return <UploadIcon />;
    case "CLIPBOARD_COPY":
      return <AssignmentOutlinedIcon />;
    case "CLIPBOARD_COPIED":
      return <AssignmentTurnedInOutlinedIcon />;
    case "IMAGES":
      return <ImagesIcon />;
    case "FILES":
      return <FilesIcon />;
    case "FONTS":
      return <FontsIcon />;
  /* 
    case "CONDITION":
      return <ConditionIcon />; */
    case "FIELD_MODULE":
      return <FieldIcon />;
    case "REG_MODULE":
      return <RegIcon />;
    case "EVENT_MODULE":
      return <EventIcon />;
    case "QUESTION_MODULE":
      return <QuestionIcon />;
   /*  case "CONTENT_MODULE":
      return <ContentModuleIcon />; */
    case "DATE":
    case "CALENDAR":
      return <CalendarTodayIcon />;
    case "LIST_ADD":
      return <ListAddIcon />;
    case "DRAG":
      return <DragIcon />;
    case "ADD_BOX":
      return <AddBoxIcon />;
    case "SORT":
      return <SortIcon />;
    case "OPTIONS":
    case "OPTION":
      return <OptionsIcon />;
    case "RESTORE":
      return <RestoreFromTrashIcon />;
    case "MORE":
      return <MoreVertIcon />;
    case "EDITOR":
      return <EditorIcon />;
    case "MENUITEMS":
    case "MENUITEM":
      return <MenuItemIcon />;
    case "MOBILEMENU":
      return <MobileMenuIcon />;
    case "NARROW":
      return <NarrowIcon />;
    default:
      return null;
  }
};
